import {InjectionToken} from '@angular/core';
import {AgGridOption} from '@pt/pt-models';

export const WidgetConfig = new InjectionToken<PtWidgetModuleConfig>('WidgetConfig');

export interface PtWidgetModuleConfig {
  env: PtWidgetModuleConfigEnv
}

export interface PtWidgetModuleConfigEnv {
  production: boolean,
  endPoint: string,
  lockDurationSec: number,
  defaultGridOptions: AgGridOption
}
